exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".help-seccion-modal{\r\n    max-height: 336px !important;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/patrimonio/patrimonio-activos-omitidos-modal/patrimonio-activos-omitidos-modal.component.css
// module id = ../../../../../src/app/components/formulario-no-experto/secciones/modales/patrimonio/patrimonio-activos-omitidos-modal/patrimonio-activos-omitidos-modal.component.css
// module chunks = main